export default "M 3.4 0 L 16.255 0 L 16.247 4.5 L 6 4.5 L 6 18 L 3.4 18 Z M 7.5 6 L 20.355 6 L 20.325 24 L 7.5 24 Z";